var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v(_vm._s(_vm.$t('loadingSpinnerText')))]),_c('div',{attrs:{"id":"loading-content"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }